import { render } from "./stockledgerreport.vue?vue&type=template&id=1cab1c20&scoped=true"
import script from "./stockledgerreport.vue?vue&type=script&lang=js"
export * from "./stockledgerreport.vue?vue&type=script&lang=js"

import "./stockledgerreport.vue?vue&type=style&index=0&id=1cab1c20&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cab1c20"]])

export default __exports__